export default "/_next/static/chunks/fonts/lato-300-dc76fa21c09d3cec2243b9edef724982.woff2";